// You can customize the template with the help of this file

//Template config options
const themeConfig = {
  app: {
    appId: 'IRCAM',
    appName: 'IRCAM WEB',
    appDesc: 'Integrity RSUDCAM System',
    appLogoImage: require('@src/assets/images/icons/logo.png').default,
    copyright: 'RSUD dr. Chasbullah Abdulmadjid Kota Bekasi',
    chatUrl: 'https://api.ircamsystem.com/chathub'
  },
  layout: {
    isRTL: false,
    skin: 'semi-dark', // light, dark, bordered, semi-dark
    routerTransition: 'none', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  }
}

export default themeConfig
